"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.AcsOfflineI18nConfigurationProvider = void 0;
const acs_offline_i18n_configuration_provider_1 = __importDefault(require("./acs-offline-i18n-configuration-provider"));
exports.AcsOfflineI18nConfigurationProvider = acs_offline_i18n_configuration_provider_1.default;
//# sourceMappingURL=index.js.map